import { render, staticRenderFns } from "./BeHorizontalCalendar.vue?vue&type=template&id=6c79f36a&scoped=true"
import script from "./BeHorizontalCalendar.vue?vue&type=script&lang=js"
export * from "./BeHorizontalCalendar.vue?vue&type=script&lang=js"
import style0 from "./BeHorizontalCalendar.vue?vue&type=style&index=0&id=6c79f36a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c79f36a",
  null
  
)

export default component.exports